import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TabsPage } from './tabs.page';

const routes: Routes = [
  {
    path: '',
    component: TabsPage,
    children: [
      {
        path: 'home',
        loadChildren: () => import('../home/home.module').then(m => m.HomePageModule)
      },
      {
        path: 'home/product/:id',
        loadChildren: () => import('../product/product.module').then(m => m.ProductPageModule)
      },
      {
        path: 'home/slide/:id',
        loadChildren: () => import('../slide/slide.module').then(m => m.SlidePageModule)
      },
      {
        path: 'categories',
        loadChildren: () => import('../categories/categories.module').then(m => m.CategoriesPageModule)
      },
      {
        path: 'categories/products/:id',
        loadChildren: () => import('../products/products.module').then(m => m.ProductsPageModule)
      },
      {
        path: 'categories/products/:cat_id/product/:id',
        loadChildren: () => import('../product/product.module').then(m => m.ProductPageModule)
      },
      {
        path: 'cart',
        loadChildren: () => import('../cart/cart.module').then(m => m.CartPageModule)
      },
      {
        path: 'cart/confirmorder',
        loadChildren: () => import('../confirmorder/confirmorder.module').then(m => m.ConfirmorderPageModule)
      },
      {
        path: 'orders',
        loadChildren: () => import('../orders/orders.module').then(m => m.OrdersPageModule)
      },
      {
        path: 'orders/order/:id',
        loadChildren: () => import('../order/order.module').then(m => m.OrderPageModule)
      },
      {
        path: 'tab3',
        loadChildren: () => import('../tab3/tab3.module').then(m => m.Tab3PageModule)
      },
      {
        path: 'tab3/profile',
        loadChildren: () => import('../profile/profile.module').then(m => m.ProfilePageModule)
      },
      {
        path: 'tab3/addresses',
        loadChildren: () => import('../addresses/addresses.module').then(m => m.AddressesPageModule)
      },
      {
        path: 'tab3/addresses/address/:id',
        loadChildren: () => import('../address/address.module').then(m => m.AddressPageModule)
      },
      {
        path: 'tab3/addresses/addaddress',
        loadChildren: () => import('../addaddress/addaddress.module').then(m => m.AddaddressPageModule)
      },
      {
        path: 'tab3/loyalty',
        loadChildren: () => import('../loyalty/loyalty.module').then(m => m.LoyaltyPageModule)
      },
      {
        path: '',
        redirectTo: '/tabs/categories',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: 'tabs',
    redirectTo: '/tabs/categories',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
})
export class TabsPageRoutingModule {}
